import React from "react";

const Chom = () => {
  return (
    <div className="chom-container">
      <p className="chom-title">
        The ticket price was already affordable, now it's even more attractive.
      </p>
      <h3 className="chom-subtitle">
        Book your flight with us and enjoy a 10% discount on all routes.
        <br />
        Save 10% on all routes.
        <br />
        Grab the offer to reach your desired destination.
      </h3>
      <button className="chom-button">Book Now</button>
    </div>
  );
};

export default Chom;
